<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-form-label style="margin-top: 20px;margin-right: 10px" for="serial_number">
                {{ $t('pos.pos_replacement') }}
            </kt-form-label>
            <hr style="width:100%">
            <kt-panel-body>
                <form @submit.prevent="submit" id="pos_replacement">
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="pos_type">
                                    {{ $t('pos.pos_type') }} {{ $t('pos.new') }}
                                </kt-form-label>
                                <select
                                        id="pos_type"
                                        name="pos_type"
                                        v-model="form_data.pos_type"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-for="(value,index) in customer_data.pos_types"
                                            :value="index"
                                    >
                                        {{ value }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="current_status">
                                    {{ $t('pos.current_status') }}
                                </kt-form-label>
                                <select
                                        id="current_status"
                                        name="current_status"
                                        v-model="form_data.current_status"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-for="(value,index) in customer_data.current_status"
                                            :value="index"
                                    >
                                        {{ value }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="pos_model">
                                    {{ $t('pos.pos_model') }} {{ $t('pos.new') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="pos_model"
                                        name="pos_model"
                                        v-model="form_data.pos_model"
                                        class="form-control kt-selectpicker"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="serial_number">
                                    {{ $t('pos.serial_number') }} {{ $t('pos.new') }}
                                </kt-form-label>
                                <kt-form-control
                                        id="serial_number"
                                        name="serial_number"
                                        v-model="form_data.serial_number"
                                        class="form-control kt-selectpicker"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="replacement_reason_id">
                                    {{ $t('pos.replacement_reason') }}
                                </kt-form-label>
                                <select
                                        id="replacement_reason_id"
                                        name="replacement_reason_id"
                                        v-model="form_data.replacement_reason_id"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-for="(value,index) in customer_data.replacement_reasons"
                                            :value="index"
                                    >
                                        {{ value }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-form-action class="mt-4">
                        <kt-button
                                class="m-2"
                                size="md"
                                variant="success"
                                @click="sendData"
                                v-bind:wide="true"
                                id="submit_btn"
                        >
                            {{ $t('panel.profile.update.wizard.form.btn.submit') }}
                        </kt-button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import $ from "jquery";
import {KTApp} from '@/plugins/core/app'
import {posService} from '@/common/api.service'
import {mapGetters} from "vuex";
import {i18n} from "@/plugins/i18n";


export default {
    components: {
        'main-content': mainContent,
    },
    computed: {
        ...mapGetters('pos', [
            'customer_data'
        ]),
    },
    mounted() {
        this.$store.dispatch('pos/fetch').finally(() => {
            this.afterDispatch()
        })
    },
    methods: {
        afterDispatch() {
            setTimeout(
                    $('.kt-selectpicker').selectpicker({
                        size: 6,
                        liveSearch: false,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_chose')

                    }), 2000)


        },
        sendData(e) {
            let form = $('#pos_replacement')
            let btn = $('#submit_btn')
            this.form_data.followup_code = this.$route.params.followup_code
            this.form_data.terminal_id = this.$route.params.terminal_id

            KTApp.progress(btn)

            posService.posReplacement(this.form_data).then(response => {
                this.$router.push('/pos')
            })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
        }
    },
    data() {
        return {
            form_data: {},
        }
    },
}
</script>

<style>

</style>